import styled from "styled-components";

export const MainHeaderContainer = styled.header`
	color: #fff;
	padding: 15px 40px;
	height: 80px;
	background-color: #000000;
	position: fixed;
	z-index: 4 !important;
	width: 100%;
`;

export const Container = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;
	font-family: "Roboto";
	padding-bottom: 12px;
	position: relative;
	z-index: 3;
`;

export const IconContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	z-index: 4;
`;
export const ToggleButton = styled.div`
	margin-left: -25px;
	font-size: 18px;
	cursor: pointer;
`;

export const Logo = styled.img`
	width: 100%;
	height: 35px;
	position: relative;
	z-index: 4;
	cursor: pointer;
`;

export const Circle = styled.div<{ $backgroundPhoto?: string | null }>`
	color: #fff;
	padding: 13px;
	width: 50px;
	height: 50px;
	background: ${(props) =>
		props.$backgroundPhoto === null
			? "#6d767e"
			: `url(${props.$backgroundPhoto}) no-repeat center center/cover`};
	border-radius: 50%;
	cursor: pointer;
	display: flex;
	justify-content: center;
	align-items: center;
`;

export const DropdownOverlay = styled.div`
	position: fixed;
	display: block;
	width: 100%;
	height: 100%;
	top: 0px;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 2;
	cursor: pointer;
`;

export const HeaderUserInfo = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 10px;
`;


